<div class="ssp-modal">
  <button type="button" class="ssp-close" aria-label="Close" (click)="maybeLater()">
    <i class="sd sd-x-close" aria-hidden="true"></i>
  </button>

  <div class="ssp-illustration">
    <svg viewBox="0 0 200 130" width="180" height="117" aria-hidden="true">
      <ellipse cx="100" cy="65" rx="92" ry="58" fill="#EDE9F7" />

      <path d="M36 30 l3 7 7 3 -7 3 -3 7 -3 -7 -7 -3 7 -3 z" fill="#C9C2F0" />
      <path d="M168 40 l2.5 5.5 5.5 2.5 -5.5 2.5 -2.5 5.5 -2.5 -5.5 -5.5 -2.5 5.5 -2.5 z" fill="#F3B27A" />
      <path d="M158 98 l2 4.5 4.5 2 -4.5 2 -2 4.5 -2 -4.5 -4.5 -2 4.5 -2 z" fill="#C9C2F0" />
      <path d="M30 90 l2 4.5 4.5 2 -4.5 2 -2 4.5 -2 -4.5 -4.5 -2 4.5 -2 z" fill="#F3B27A" />

      <rect x="16" y="48" rx="10" ry="10" width="36" height="24" fill="#F5F3FC" stroke="#C9C2F0" stroke-width="1.5"/>
      <path d="M27 72 l-7 8 v-8 z" fill="#F5F3FC" stroke="#C9C2F0" stroke-width="1.5"/>
      <text x="24" y="65" font-size="15" fill="#7B7FE0" font-family="Georgia, serif">&#8220;</text>

      <rect x="148" y="24" rx="8" ry="8" width="26" height="20" fill="#fff" stroke="#3FAE6A" stroke-width="1.5"/>
      <text x="154" y="40" font-size="14" fill="#3FAE6A" font-family="Georgia, serif">&#8220;</text>

      <rect x="83" y="42" width="34" height="26" rx="4" fill="#fff" stroke="#2B2B2B" stroke-width="2" />
      <path d="M100 62 c-7 -5 -11 -9 -11 -13.5 c0 -3 2.4 -5.5 5.4 -5.5 c2 0 3.7 1 4.6 2.5 c0.9 -1.5 2.6 -2.5 4.6 -2.5 c3 0 5.4 2.5 5.4 5.5 c0 4.5 -4 8.5 -11 13.5 z" fill="#EA651F" />
    </svg>
  </div>

  <h2 class="ssp-title">Your journey can inspire others!</h2>
  <span class="ssp-title-accent"></span>
  <p class="ssp-subtitle">Share your apprenticeship experience and help future learners make confident choices.</p>

  <div class="ssp-features">
    <div class="ssp-feature">
      <span class="ssp-feature__icon ssp-feature__icon--purple">
        <i class="sd sd-users-01" aria-hidden="true"></i>
      </span>
      <span class="ssp-feature__text">
        <strong>Inspire</strong>
        future apprentices
      </span>
    </div>
    <div class="ssp-feature">
      <span class="ssp-feature__icon ssp-feature__icon--yellow">
        <i class="sd sd-star-04" aria-hidden="true"></i>
      </span>
      <span class="ssp-feature__text">
        <strong>Highlight</strong>
        your achievements
      </span>
    </div>
    <div class="ssp-feature">
      <span class="ssp-feature__icon ssp-feature__icon--green">
        <i class="sd sd-check-verified-01" aria-hidden="true"></i>
      </span>
      <span class="ssp-feature__text">
        <strong>Be a part of</strong>
        our success stories
      </span>
    </div>
  </div>

  <div class="ssp-actions">
    <button type="button" class="ssp-btn ssp-btn--outline" (click)="maybeLater()">Maybe Later</button>
    <button type="button" class="ssp-btn ssp-btn--filled" (click)="shareStory()">
      <i class="sd sd-message-heart-square" aria-hidden="true"></i>
      Share My Story
      <i class="sd sd-arrow-narrow-right" aria-hidden="true"></i>
    </button>
  </div>

  <p class="ssp-footer-note">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="5" y="11" width="14" height="9" rx="2" stroke="currentColor" stroke-width="2"/>
      <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
    It only takes a few minutes. You can skip anytime.
  </p>
</div>
